import { PHONE_TEL_LINK, EMAIL } from "@/constants/business";

const SITE_URL = "https://expressdeliveryco.fr";

export function localBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE_URL}/#organization`,
    name: "Express Delivery",
    image: `${SITE_URL}/logo.png`,
    telephone: PHONE_TEL_LINK.replace("tel:", ""),
    email: EMAIL,
    address: {
      "@type": "PostalAddress",
      addressLocality: "Le Havre",
      addressRegion: "Normandie",
      addressCountry: "FR",
    },
    areaServed: "Normandie",
    url: SITE_URL,
  };
}

export function serviceSchema({ name, description, url }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name,
    description,
    url: `${SITE_URL}${url}`,
    provider: { "@type": "LocalBusiness", name: "Express Delivery" },
    areaServed: "Normandie",
  };
}

export function faqSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.label,
      item: `${SITE_URL}${item.href}`,
    })),
  };
}

export { SITE_URL };
